import axios from 'axios';
import api from '@src/api';
import store from '@state/store';

export const state = initialState();

function initialState() {
  return {
    myCohorts: [],
    selectedCohort: null,
  };
}

export const getters = {
  myCohorts(state) {
    return state.myCohorts;
  },
  fyf5Cohort(state) {
    // assuming it is the first and only cohort a trainer is in!
    return state.myCohorts && state.myCohorts.length > 0 && state.myCohorts[0];
  },
};

export const mutations = {
  SET_MY_COHORTS(state, newValue) {
    state.myCohorts = newValue;
  },
  setSelectedCohort(state, newValue) {
    state.selectedCohort = newValue;
  },
};

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch }) {
    dispatch('getCohorts');
  },
  getCohorts({ commit }) {
    const isEnrolled = store.getters['auth/isTrainerEnrolledInACohort'];
    const url = api.URL_GET_LEARN_COHORTS.concat(
      isEnrolled ? '' : '?allAvailableCohorts=true'
    );
    return axios
      .get(url)
      .then((res) => {
        if (res.data.success) {
          commit('SET_MY_COHORTS', res.data.cohorts);
        }
      })
      .catch((err) => {
        console.warn(err);
      });
  },
  enrollTrainer({ dispatch }, cohortId) {
    const url = api.URL_ENROLL_TRAINER_IN_COHORT.replace(':cohortId', cohortId);

    // No request body needed
    return axios
      .post(url)
      .then(async (res) => {
        if (res.data.success) {
          // need to validate and update the currentUser.trainer obj with the cohort id
          store.commit('auth/SET_AUTH_CHECKED', false);
          await store.dispatch('auth/validate');
          await dispatch('getCohorts');
          return res.data;
        }
      })
      .catch((err) => {
        console.warn(err);
      });
  },
  trackModuleWatch({ dispatch }, { cohortId, moduleSlug }) {
    const url = api.URL_TRACK_COHORT_WATCH.replace(
      ':cohortId',
      cohortId
    ).replace(':moduleSlug', moduleSlug);
    console.log(url);
    // No request body needed
    return axios
      .post(url)
      .then(async (res) => {
        if (res.data.success) {
          await store.dispatch('auth/validate');
          await dispatch('getCohorts');
          return res.data;
        }
      })
      .catch((err) => {
        console.warn(err);
      });
  },
};
